import * as Select from '@studio/design-system/select';
import { BaudRates, toBaudRate } from '@studio/models/net';
import type { BaudRate as M_BaudRate } from '@studio/models/net';
import { useLatestFn, useLazyRef } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import type { Props } from './types.js';

const toString = (v: M_BaudRate): string => v.toString();

/** `<BaudRate>` component. */
export const BaudRate = ({ baudRate, size, ...props }: Props): ReactElement => {
  const handleValueChange = useLatestFn((nextValue: string) => {
    const nextBaudRate = toBaudRate(nextValue);

    if (nextBaudRate && nextBaudRate !== baudRate.value) {
      baudRate(nextBaudRate);
    }
  });

  return (
    <Select.Root onValueChange={handleValueChange} size={size} value={toString(baudRate.value)}>
      <Select.Trigger {...props}>
        <Select.Value />
      </Select.Trigger>

      <Select.Content>
        {
          useLazyRef(() =>
            BaudRates.map((µ) => (
              <Select.Item key={µ} value={toString(µ)}>
                <Select.ItemText>{µ.toLocaleString()} Baud</Select.ItemText>
              </Select.Item>
            ))
          ).current
        }
      </Select.Content>
    </Select.Root>
  );
};
